@if (items().length > 0) {
  <div class="recommendations" [class.border-line]="!thumbSize()" data-testid="cart-recommendations">
    <h5>{{ 'CART.RECOMMENDATION' | translate }}</h5>
    <div class="slider" #slider>
      @for (recommendation of items(); track recommendation.item.id) {
        <app-item
          [item]="recommendation.item"
          [subSectionId]="recommendation.subSectionId"
          [isOptionalSubSection]="recommendation.isOptionalSubSection"
          [isGridView]="true"
          [compact]="true"
          [alwaysShowImage]="true">
        </app-item>
      }
    </div>
    @if (thumbSize(); as size) {
      <div class="scroll-track" aria-hidden="true">
        <div class="scroll-thumb" [style.width.%]="size"></div>
      </div>
    }
  </div>
}
